// extracted by mini-css-extract-plugin
module.exports = {"tableScrollContainer":"styles_tableScrollContainer__1uVDe"};